import { QueryClient } from '@tanstack/react-query';

export interface CreateQueryClientOptions {
  staleTime?: number;
  gcTime?: number;
  retry?: number | boolean;
  refetchOnWindowFocus?: boolean;
}

export function createQueryClient(options: CreateQueryClientOptions = {}): QueryClient {
  const {
    staleTime = 1000 * 60 * 5,
    gcTime = 1000 * 60 * 10,
    retry = 1,
    refetchOnWindowFocus = false,
  } = options;

  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime,
        gcTime,
        retry,
        refetchOnWindowFocus,
        throwOnError: false,
      },
      mutations: {
        retry: 0,
        throwOnError: false,
      },
    },
  });
}
